import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import system from '../../system';
import styles from './index.module.css';
const SYSTEM_PROPS = ['flexProps', 'marginProps', 'floatProps', 'positioningProps', 'widthProps'];
const List = /*#__PURE__*/function () {
  const List = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      as,
      children,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const classNames = {
      [styles.root]: true,
      [styles.bullet]: as === 'ul',
      [styles.decimal]: as === 'ol'
    };
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      ref: ref,
      className: cx(classNames, className),
      style: style,
      as: as
    }), children);
  });
  List.displayName = 'List';
  List.identifier = List.displayName;
  List.clonableProps = SYSTEM_PROPS;
  List.defaultProps = {
    as: 'ul'
  };
  return List;
}();
export default List;